// extracted by mini-css-extract-plugin
module.exports = {"container":"parliamentaryResult_container__PCLsy"};